import React, { useMemo } from 'react';
import { Typography } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { ListingForm } from 'components/shared/TableListing';
import { formatCurrency } from 'utils';
import { calculateSubsidyBreakdown } from '../../lib';
import { SubsidyTableRow } from '../../types';

interface Props {
  rowIndex: number;
  subsidyPercent: number;
  dnetCoefficient: number;
  dealerParticipationPercent: number;
  storedValue?: number;
}

export const OemContributionCell = ({
  rowIndex,
  subsidyPercent,
  dnetCoefficient,
  dealerParticipationPercent,
  storedValue,
}: Props) => {
  const { control } = useFormContext<ListingForm<SubsidyTableRow>>();
  const row = useWatch({ control, name: `bodyFields.${rowIndex}` });

  const oemContribution = useMemo(() => {
    if (storedValue !== undefined) return storedValue;

    return calculateSubsidyBreakdown({
      financeAmount: row?.financeAmount ?? 0,
      dnet: row?.dnet ?? 0,
      subsidyPercent,
      dnetCoefficient,
      dealerParticipationPercent,
    }).oemContribution;
  }, [storedValue, row?.dnet, row?.financeAmount, subsidyPercent, dnetCoefficient, dealerParticipationPercent]);

  return <Typography fontWeight={500}>{formatCurrency(oemContribution, true)}</Typography>;
};
